import VolunteerHistory from '@/models/childcare-provider/volunteerHistory';
import Cece from '@/models/childcare-provider/cece';
import fileModel from '@/helpers/file';

export default class BadgesModel {
    public ece: boolean = false;
    public eceFile: fileModel = new fileModel();
    public eceActivate: boolean = false;

    public highSchoolDiploma: boolean = false;
    public highSchoolDiplomaFile: fileModel = new fileModel();
    public highSchoolDiplomaActivate: boolean = false;

    public ged: boolean = false;
    public gedFile: fileModel = new fileModel();
    public gedActivate: boolean = false;

    public firstAid: boolean = false;
    public firstAidFile: fileModel = new fileModel();
    public firstAidActivate: boolean = false;

    public cprInfant: boolean = false;
    public cprInfantFile: fileModel = new fileModel();
    public cprInfantActivate: boolean = false;

    public cpr: boolean = false;
    public cprFile: fileModel = new fileModel();
    public cprActivate: boolean = false;

    public cda: boolean = false;
    public cdaFile: fileModel = new fileModel();
    public cdaActivate: boolean = false;

    public foodHandlerPermit: boolean = false;
    public foodHandlerPermitFile: fileModel = new fileModel();
    public foodHandlerPermitActivate: boolean = false;

    public babysitCourse: boolean = false;
    public babysitCourseFile: fileModel = new fileModel();
    public babysitCourseActivate: boolean = false;

    public vulnerableSector: boolean = false;
    public vulnerableSectorFile: fileModel = new fileModel();

    //Social media
    public facebook: string = '';    
    public instagram: string = '';

    public cameraType: string = '';
    public liveMonitoryLink: string = '';
    public personalityTest: string = '';

    public insuranceCompanyName: string = '';
    public insurancePolicyNumber: string = '';
    public insuranceActivate: boolean = false;

    // public volunteerHistories: Array<VolunteerHistory> | null = new Array<VolunteerHistory>();
    // public cece: Cece | null = new Cece();
    public volunteerHistories: Array<VolunteerHistory> | null = null;
    public cece: Cece | null = null; 

    public comments: boolean = true;
    public parentCosign: boolean = false;
}